import { render, staticRenderFns } from "./SubjectSave.vue?vue&type=template&id=90477f2e&"
import script from "./SubjectSave.vue?vue&type=script&lang=js&"
export * from "./SubjectSave.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSave.vue?vue&type=style&index=0&id=90477f2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports